import { render, staticRenderFns } from "./relation-card.vue?vue&type=template&id=979b5788&scoped=true"
import script from "./relation-card.vue?vue&type=script&lang=js"
export * from "./relation-card.vue?vue&type=script&lang=js"
import style0 from "./relation-card.vue?vue&type=style&index=0&id=979b5788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979b5788",
  null
  
)

export default component.exports